<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="12" class="mt-1">
            <h4>{{ $dt('global.extensions_view_title', 'Extension') }}</h4>
          </b-col>
        </b-row>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row v-if="extension">
            <b-col cols="12">
              <div>
                <p class="font-weight-bold">{{ $dt('extension.name', 'Name') }}:</p>
                <p class="ml-2">{{ extension.name }}</p>
              </div>
              <div>
                <p class="font-weight-bold">{{ $dt('extension.web_store_url', 'Web Store Url') }}:</p>
                <p class="ml-2">
                  <a :href="extension.web_store_url" target="blank">{{extension.web_store_url}}</a>
                </p>
              </div>
              <div>
                <p class="font-weight-bold">{{ $dt('extension.created_at', 'Created At') }}:</p>
                <p class="ml-2">{{ extension.created_at }}</p>
              </div>
              <b-card>
                <b-form @submit.prevent="onSubmit">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="extension.is_active"
                      name="is_active"
                    >
                      Whitelist
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="extension.is_recommended"
                      name="is_active"
                    >
                      Recommended
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group label="Description">
                    <b-form-textarea
                      rows="3"
                      v-model="extension.description"
                      :state="errors.description ? false : null"
                    />
                    <b-form-invalid-feedback v-if="errors.description">
                      {{ errors.description[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Category">
                    <b-form-input
                      v-model="extension.category"
                      :state="errors.category ? false : null"
                    />
                    <b-form-invalid-feedback v-if="errors.category">
                      {{ errors.category[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Install Count">
                    <b-form-input
                      v-model="extension.install_count"
                      :state="errors.install_count ? false : null"
                    />
                    <b-form-invalid-feedback v-if="errors.install_count">
                      {{ errors.install_count[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-button
                    type="submit"
                    variant="primary"
                    :disabled="spinners.contentIsLoading"
                  >
                    {{ $dt('global.save', 'Save') }}
                  </b-button>
                </b-form>
              </b-card>
              <div>
                <p class="font-weight-bold">
                  {{ $dt('extension.request_count', 'Times Requested') }}: {{ extension.request_count }}
                </p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table
                :fields="usersTableFields"
                :items="usersTableItems"
                responsive
                bordered
                class="table-sm text-center"
              />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Services from '@/services';

export default {
  name: 'ExtensionView',
  props: ['id'],
  data() {
    return {
      extension: null,
      errors: {},
      spinners: {
        contentIsLoading: false,
      },
    };
  },
  computed: {
    webstoreUrl() {
      return `https://chromewebstore.google.com/detail/${this.id}`;
    },
    usersTableItems() {
      if (!this.extension || !this.extension.request_users) {
        return [];
      }

      return this.extension.request_users;
    },
    usersTableFields() {
      return [
        { key: 'id', label: this.$dt('user.id', 'Id') },
        { key: 'full_name', label: this.$dt('user.name', 'Name') },
        { key: 'email', label: this.$dt('user.email', 'Email') },
      ];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.spinners.contentIsLoading = true;

      Services.extensions.view(this.id).then(({ data }) => {
        this.extension = data;
      }).catch(() => {
        this.alertError();
      }).finally(() => {
        this.spinners.contentIsLoading = false;
      });
    },
    async onSubmit() {
      try {
        this.spinners.contentIsLoading = true;
        this.errors = {};
        const response = await Services.extensions.update(this.id, this.extension);
        this.extension = response.data;
        this.alertSuccess();
      } catch (error) {
        console.error(error);
        this.errors = error.errors || {};
        this.alertError();
      } finally {
        this.spinners.contentIsLoading = false;
      }
    },
  },
};
</script>
